import { Field, Fieldset } from '@oaknorth/component-core-v2';

import { FormFieldProps } from './types';

export interface FormFieldWrapperProps extends FormFieldProps {
  children: React.ReactNode;
  error?: string;
  touched?: boolean;
}

export const FormFieldWrapper = ({
  fieldName,
  labelText,
  children,
  error,
  touched,
  helperText,
  'data-testid': testId,
  disabled,
}: FormFieldWrapperProps) => {
  const isInvalid = !!error && touched;
  return (
    <Field
      invalid={isInvalid}
      id={fieldName}
      label={labelText}
      helperText={helperText}
      errorText={error}
      data-testid={testId}
      disabled={disabled}
    >
      {children}
    </Field>
  );
};

export const FormFieldSetWrapper = ({
  fieldName,
  labelText,
  children,
  error,
  touched,
  helperText,
  'data-testid': testId,
}: FormFieldWrapperProps) => {
  const isInvalid = !!error && touched;
  return (
    <Fieldset.Root invalid={isInvalid} id={fieldName} data-testid={testId}>
      <Fieldset.Legend>{labelText}</Fieldset.Legend>
      {children}
      {helperText && <Fieldset.HelperText id={`${fieldName}-helper-text`}>{helperText}</Fieldset.HelperText>}
      {error && <Fieldset.ErrorText id={`${fieldName}-error-text`}>{error}</Fieldset.ErrorText>}
    </Fieldset.Root>
  );
};
